import { Injectable } from '@angular/core';
import { PdfReportStore } from './pdf-report.store';
import {
    createPdfReportItem,
    PdfReportItem,
    PdfReportItemInput
} from './pdf-report.model';
import { OrArray } from '@datorama/akita/src/lib/types';

@Injectable({ providedIn: 'root' })
export class PdfReportService {
    constructor(private _store: PdfReportStore) {}

    /** registerPdfReportItems
     * @description Register one or more PDF report items in the store
     * @param item PdfReportItemInput or array of PdfReportItemInput
     */
    registerPdfReportItems(item: PdfReportItemInput): PdfReportItem;
    registerPdfReportItems(item: PdfReportItemInput[]): PdfReportItem[];
    registerPdfReportItems(
        item: OrArray<PdfReportItemInput>
    ): PdfReportItem | PdfReportItem[] {
        if (Array.isArray(item)) {
            const newItems = item.map((i) => createPdfReportItem(i));
            this._store.add(newItems);
            return newItems;
        } else {
            const newItem = createPdfReportItem(item);
            this._store.add(newItem);
            return newItem;
        }
    }

    /** removePdfReportItems
     * @description Remove one or more PDF report item from the store
     * @param ids string or array of strings of the IDs of the items to remove
     */
    removePdfReportItems(ids: string | string[]) {
        this._store.remove(ids);
    }

    /** toggleState
     * @description Toggle the active state of the PDF report export modal, set to true when the export modal is open
     */
    toggleState() {
        this._store.update((state) => ({
            ui: {
                ...state.ui,
                active: !state.ui.active
            }
        }));
    }
}
